export const sortHighToLow = (array: any, sortString: string) => {
  return array.sort((a: any, b: any) => b[sortString] - a[sortString]);
};
